import * as React from "react";

const styles = require("./feedHeader.scss");

interface IProps {
  title: string;
}

export default function FeedHeader({ title }: IProps) {
  return (
    <header className={styles.container}>
      <h3 className={styles.title}>{title}</h3>
    </header>
  );
}
